'use client';

import { memo, useMemo, useState } from 'react';
import { InfoModal } from 'app/book/components/ServiceStep/components/ServiceList/components/InfoModal';
import config from 'config';

import { Box, useDisclosure } from '@chakra-ui/react';

import {
  SiteAlertPlacement,
  SiteAlertsInterface,
  SiteAlertTarget,
  SiteAlertType
} from 'types';

import { BannerView } from '../BannerView';

const {
  siteAlert: { desktop_banners }
} = config;

interface StandardBannerProps {
  areaId: number | null;
  siteAlerts: SiteAlertsInterface[];
}

const StandardBanner = ({ areaId, siteAlerts }: StandardBannerProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [selectedBanner, selectBanner] = useState<SiteAlertsInterface | null>(
    null
  );
  const banners = useMemo(
    () =>
      (siteAlerts ?? [])
        .filter(
          (alert) => alert.site_alert_placement === SiteAlertPlacement.Standart
        )
        .filter(
          (alert) =>
            alert.site_alert_target === SiteAlertTarget.Sitewide ||
            alert.site_area.some((area) => area.id === areaId)
        ),
    [siteAlerts, areaId]
  );

  const onBannerClick = (idx: number) => {
    const currentItem = banners[idx];
    selectBanner(currentItem);

    switch (currentItem.site_alert_type) {
      case SiteAlertType.Popup:
        onOpen();
        break;
      case SiteAlertType.PopupLarge:
        onOpen();
        break;
      case SiteAlertType.PopupText:
        onOpen();
        break;
      case SiteAlertType.Url:
        window.location.href = currentItem.url;
        break;
      case SiteAlertType.UrlNewTab:
        window.open(currentItem.url, '_blank');
        break;
      default:
        break;
    }
  };

  const onCloseModal = () => {
    onClose();
    selectBanner(null);
  };

  return (
    <Box
      position='relative'
      w='100vw'
      sx={{
        '.slick-slider .slick-slide': {
          padding: 0
        }
      }}
    >
      {Boolean(banners.length) && (
        <BannerView banners={banners} onBannerClick={onBannerClick} />
      )}

      <InfoModal
        isOpen={isOpen}
        onClose={onCloseModal}
        title={selectedBanner?.site_alert_cat_name ?? ''}
        subtitle={selectedBanner?.name ?? ''}
        description={selectedBanner?.text ?? ''}
        banners={desktop_banners}
      />
    </Box>
  );
};

export default memo(StandardBanner);
